export default __webpack_public_path__ + "static/media/strategy.73a9d53d.svg";